






import Vue from "vue";
import Dashboard from "./components/Dashboard.vue";

export default Vue.extend({
  name: "App",
  components: { Dashboard },
  data: () => ({})
});
